import React, { useMemo } from "react";
import { Fab, useMediaQuery, Portal } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { customTheme } from "../customTheme";
import { Link } from "react-router-dom";

export default function CustomCreateButton(props) {
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const { label = "Create", basePath, resource, style } = props;

    const location = useMemo(
        () => (basePath ? `${basePath}/create` : `/${resource}/create`),
        [basePath, resource]);

    return (<Portal>
        <Fab
            variant={isSmallDevice ? "round" : "extended"}
            color="primary"
            component={Link}
            to={location}
            style={{ position: "fixed", right: isSmallDevice ? 25 : 50, bottom: isSmallDevice ? 30 : 40, boxShadow: "none", zIndex: 10, ...style }}
        >
            <AddIcon />
            {!isSmallDevice && <div style={{ margin: "0 10px", fontSize: 13, fontFamily: "Poppins-Medium", textTransform: "none", letterSpacing: "0.04rem" }}>{label}</div>}
        </Fab>
    </Portal>);
}